export const GET_STEM_KITS = 'get_stem_kits';
export const GET_STEM_KIT = 'get_stem_kit';
export const ADD_STEM_KIT_ORDER = 'add_stem_kit_order'